import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { OrganizationsStore } from 'wflow-main-app/src/app/store/organizations/organizations.model';
import { selectCurrentOrganization } from 'wflow-main-app/src/app/store/organizations/organizations.selectors';

const isDemo = createSelector(
  selectCurrentOrganization,
  (org) => !!org?.isDemo,
);

@Component({
  imports: [TranslateModule],
  selector: 'is-demo',
  template: `
    @if (isDemo()) {
      {{ 'Demo' | translate }}
    }
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        color: var(--wf-foreground-tertiary);
        font-weight: var(--wf-font-weight-medium);
        font-size: var(--wf-xs-font-size);
        letter-spacing: var(--wf-xs-letter-spacing);
        line-height: var(--wf-xs-line-height);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IsDemoComponent {
  readonly isDemo =
    inject<Store<OrganizationsStore>>(Store).selectSignal(isDemo);
}
